import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Radio,
  Slider,
  Checkbox,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import {
  updateSettingsGeneralRequest,
  createSettingsGeneralRequest,
  getSettingsSitesRequest,
} from "../../api/requests";
import {
  getGeneralSettingsCreatePermission,
  getGeneralSettingsUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./SettingsGeneralForm.css";
import { logout } from "../../reducers/user/actions";

const { Option } = Select;

class SettingsGeneralForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  async componentDidMount() {
    // try {
    //   const { data } = await getSettingsSitesRequest();
    //   this.setState({ sites: data });
    // } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const settings = { ...values };

          if (this.props.id) {
            await updateSettingsGeneralRequest(this.props.id, settings);
          } else {
            await createSettingsGeneralRequest(settings);
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      generalSettingsCreatePermission,
      generalSettingsUpdatePermission,
      id,
      isNew,
    } = this.props;

    const isEditable = id
      ? generalSettingsUpdatePermission
      : generalSettingsCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              "Add setting"
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Name:</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "name", ""),
                  })(<Input disabled={!isEditable} placeholder="Name" />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Value:</b>
                <Form.Item>
                  {getFieldDecorator("content", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "content", ""),
                  })(<Input disabled={!isEditable} placeholder="Content" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>Type</b>
                <Form.Item>
                  {getFieldDecorator("setting_type", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "setting_type"),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder="Setting type"
                      style={{ width: "100%" }}
                      allowClear
                    >
                      <Option value="contact_us_email">Contact us email</Option>
                      <Option value="password_expire_policy">
                        Password expire policy(days)
                      </Option>
                      <Option value="private_url_expire_policy">
                        Private url expire policy (seconds)
                      </Option>
                      <Option value="disable_private_urls">
                        Disable private urls
                      </Option>
                      <Option value="maximum_number_of_subjects">
                        Maximum number of subjects
                      </Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            {/*<Col lg={12}>
              <label>
                <b>Site ID</b>
                <Form.Item>
                  {getFieldDecorator('site_id', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'site_id')
                  })(<Select placeholder='Select Site ID' style={{ width: '100%'}} allowClear>
                    {sites.map(site => (
                      <Option key={site.id} value={site.id}>{site.name}</Option>
                    ))}
                  </Select>)}
                </Form.Item>
              </label>
            </Col>*/}
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  generalSettingsCreatePermission: getGeneralSettingsCreatePermission(state),
  generalSettingsUpdatePermission: getGeneralSettingsUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "settings-general" })(
  connect(mapStateToProps, mapDispatchToProps)(SettingsGeneralForm)
);



// WEBPACK FOOTER //
// ./src/components/SettingsGeneralForm/SettingsGeneralForm.js